import { render, staticRenderFns } from "./songFuwu.vue?vue&type=template&id=0de24c74&scoped=true"
import script from "./songFuwu.vue?vue&type=script&lang=js"
export * from "./songFuwu.vue?vue&type=script&lang=js"
import style0 from "./songFuwu.vue?vue&type=style&index=0&id=0de24c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de24c74",
  null
  
)

export default component.exports